<span class="app-account-profile__avatar" aria-hidden="true">
  @if (initials()) {
    {{ initials() }}
  } @else {
    <span class="fa-solid fa-user"></span>
  }
</span>
<div class="app-account-profile__copy">
  <div class="app-account-profile__name" [title]="displayName()">{{ displayName() }}</div>
  <div class="app-account-profile__role" [title]="roleLabel()">{{ roleLabel() }}</div>
</div>
